{
  "fr": {
    "errors": {
      "generic": "Une erreur s'est produite",
      "imageNotLoaded": "L'image n'a pas pu être chargée.",
      "upload": {
        "oneFile": "Un seul fichier peut être téléchargé à la fois.",
        "generic": "Une erreur s'est produite lors du téléchargement.",
        "fileTooLarge": "Le fichier \"%{filename}\" dépasse la taille maximale autorisée de %{size} Mo.",
        "invalidFileType": "Le fichier \"%{filename}\" n'est pas d'un type autorisé. Les types autorisés sont : %{types}."
      }
    }
  }
}
